import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import MarketplaceAdminForm from "./marketplaceAdminForm";

const MarketplaceCreate = () => {

  return (
    <div className="marketplace-create">
      <div className="container">
        <MarketplaceAdminForm/>
      </div>
    </div>
  );
}

MarketplaceCreate.propTypes = {
  currentUser: PropTypes.object,
  marketplaces: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

MarketplaceCreate.defaultProps = {
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
    marketplaces: state.marketplaces.marketplaces,
    loading: state.marketplaces.loading,
    error: state.marketplaces.error,
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketplaceCreate);